// Sliby a úkoly (docs/SPEC.md 2.6): slib = text + termín + klient (+ zakázka) + zdroj; úkol = interní.
import { z } from 'zod'
import { promiseStatusSchema, taskStatusSchema } from './enums'

const isoDate = z.string().datetime({ offset: true })

export const createPromiseSchema = z.object({
  text: z.string().trim().min(2, 'Napiš, co jsi slíbil').max(500),
  dueAt: isoDate,
  clientId: z.string().uuid('Vyber klienta'),
  jobId: z.string().uuid().optional().nullable(),
  assigneeId: z.string().uuid().optional().nullable(),
})
export type CreatePromiseInput = z.infer<typeof createPromiseSchema>

export const updatePromiseSchema = z.object({
  text: z.string().trim().min(2).max(500).optional(),
  dueAt: isoDate.optional(),
  clientId: z.string().uuid().optional(),
  jobId: z.string().uuid().optional().nullable(),
  assigneeId: z.string().uuid().optional().nullable(),
  /** done = Splněno jedním klepnutím (zruší naplánované připomínky), open = vrátit. */
  status: promiseStatusSchema.optional(),
})
export type UpdatePromiseInput = z.infer<typeof updatePromiseSchema>

export const PROMISE_FILTERS = ['open', 'overdue', 'today', 'done', 'cancelled', 'all'] as const
export const listPromisesQuerySchema = z.object({
  filter: z.enum(PROMISE_FILTERS).default('open'),
  clientId: z.string().uuid().optional(),
  jobId: z.string().uuid().optional(),
  assigneeId: z.string().uuid().optional(),
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(100),
})
export type ListPromisesQuery = z.infer<typeof listPromisesQuerySchema>

export interface PromiseItem {
  id: string
  text: string
  dueAt: string
  status: 'open' | 'done' | 'cancelled'
  doneAt: string | null
  clientId: string
  clientName: string
  clientPhoneE164: string | null
  jobId: string | null
  jobTitle: string | null
  assigneeId: string | null
  assigneeName: string | null
  /** Po termínu a stále otevřený (počítá api v čase organizace). */
  overdue: boolean
  sourceInteractionId: string | null
  sourceQuote: string | null
  createdAt: string
  updatedAt: string
}

export const createTaskSchema = z.object({
  title: z.string().trim().min(2, 'Napiš, co je třeba udělat').max(300),
  dueAt: isoDate.optional().nullable(),
  assigneeId: z.string().uuid().optional().nullable(),
  jobId: z.string().uuid().optional().nullable(),
})
export type CreateTaskInput = z.infer<typeof createTaskSchema>

export const updateTaskSchema = z.object({
  title: z.string().trim().min(2).max(300).optional(),
  dueAt: isoDate.optional().nullable(),
  assigneeId: z.string().uuid().optional().nullable(),
  jobId: z.string().uuid().optional().nullable(),
  status: taskStatusSchema.optional(),
})
export type UpdateTaskInput = z.infer<typeof updateTaskSchema>

export const TASK_FILTERS = ['open', 'overdue', 'today', 'done', 'all'] as const
export const listTasksQuerySchema = z.object({
  filter: z.enum(TASK_FILTERS).default('open'),
  assigneeId: z.string().uuid().optional(),
  jobId: z.string().uuid().optional(),
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(100),
})
export type ListTasksQuery = z.infer<typeof listTasksQuerySchema>

export interface TaskItem {
  id: string
  title: string
  dueAt: string | null
  status: 'open' | 'done'
  doneAt: string | null
  assigneeId: string | null
  assigneeName: string | null
  jobId: string | null
  jobTitle: string | null
  overdue: boolean
  sourceInteractionId: string | null
  sourceQuote: string | null
  createdAt: string
  updatedAt: string
}
